// Lib
import React, { CSSProperties, ReactNode } from 'react';

import './ElementDragPreviewRotator.scss';

type ElementDragPreviewRotatorProps = {
    elementRotation: { x: number; y: number };
    shadowIntensity: number;
    children: ReactNode;
};

/**
 * This component is used to manually rotate element drag previews based on the specified
 * elementRotation parameter. For performance, we update the values via a CSS variable rather
 * than iterating over the elements and applying styles to them directly.
 */
const ElementDragPreviewRotator = ({ elementRotation, shadowIntensity, children }: ElementDragPreviewRotatorProps) => {
    const style = {
        '--drag-preview-transform': `rotateX(${elementRotation.x}deg) rotateY(${elementRotation.y}deg)`,
        '--shadow-intensity': shadowIntensity,
    } as CSSProperties;

    return (
        <div className="ElementDragPreviewRotator" style={style}>
            {children}
        </div>
    );
};

export default React.memo(ElementDragPreviewRotator);
